import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { GetAnalyticsDto, PublicRecordingViews } from "@classview/shared-types";
import {
  UseQueryOptions,
  keepPreviousData,
  useQuery,
} from "@tanstack/react-query";

export const getRecordingViews = async ({
  from,
  to,
  organisationId,
}: GetAnalyticsDto) => {
  const response = await axiosClient.get<PublicRecordingViews[]>(
    `/analytics/recording-views`,
    { params: { from, to, organisationId } },
  );

  return response.data;
};

const getRecordingsViewKey = (
  from: string,
  to: string,
  organisationId?: string,
) => ["analytics", "recording-views", from, to, organisationId ?? "all"];

export function useGetRecordingViews(
  { from, to, organisationId }: GetAnalyticsDto,
  queryOptions?: Partial<UseQueryOptions<PublicRecordingViews[], HttpError>>,
) {
  return useQuery({
    queryKey: getRecordingsViewKey(from, to, organisationId),
    queryFn: () => getRecordingViews({ from, to, organisationId }),
    placeholderData: keepPreviousData,
    ...queryOptions,
  });
}
